import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { LoginComponent } from './login/login.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { LogoutComponent } from './logout/logout.component';
import { BasicAuthComponent } from './components/basic-auth/basic-auth.component';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { StudentAuthComponent } from './components/student-auth/student-auth.component';
import { LecturerAuthComponent } from './components/lecturer-auth/lecturer-auth.component';

@NgModule({
  declarations: [
    // prettier-ignore
    LoginComponent,
    LogoutComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    NzFormModule,
    NzIconModule,
    NzAlertModule,
    NzButtonModule,
    NzInputModule,
    NzTypographyModule,
    BasicAuthComponent,
    StudentAuthComponent,
    LecturerAuthComponent,
  ],
})
export class AuthModule {}
